import { en } from './en';
import { ro } from './ro';

export type Locale = typeof en;

export const locales = {
  en,
  ro,
} as const;

export type LocaleKey = keyof typeof locales;

// Default locale
export const defaultLocale: LocaleKey = 'en';

// Helper function to get locale
export const getLocale = (locale: LocaleKey = defaultLocale): Locale => {
  return locales[locale] || locales[defaultLocale];
};

// Helper function to get nested translation
export const t = (locale: LocaleKey, path: string): string => {
  const keys = path.split('.');
  let value: any = getLocale(locale);
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      console.warn(`Translation key not found: ${path}`);
      return path;
    }
  }
  
  return typeof value === 'string' ? value : path;
};

export { en, ro }; 